<template>
  <div class="mr-3">
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize',
        apiBodyMeasures.length > 0 ? 'selected' : ''
      ]"
      @click="fieldData.showTargetGroupModal = true"
    >
      Målgrupp / Mått
    </button>
    <b-modal
      v-model="fieldData.showTargetGroupModal"
      dialog-class="targetgroupmodal"
      scrollable
      title="Välj målgrupper / mått"
      @hidden="cancelTargetGroups"
      @ok="saveTargetGroups"
      @show="showModal"
    >
      <b-form-row>
        <b-col sm="4">
          <label for="group-selection">Grupp</label>
          <b-form-select
            id="group-selection"
            v-model="form.group.selected"
            :options="form.group.options"
            size="sm"
          />
        </b-col>

        <b-col sm="4">
          <label for="measurements-selection">Mått</label>
          <b-form-select
            id="measurements-selection"
            v-model="fieldData.measurements.selected"
            :options="fieldData.measurements.options"
            size="sm"
          />
        </b-col>

        <b-col
          sm="4"
          class="mb-2"
        >
          <label for="consolidation-selection">Konsolidering</label>
          <b-form-select
            id="consolidation-selection"
            v-model="form.consolidation.selected"
            size="sm"
          >
            <option
              v-for="(option, idx) in form.consolidation.options"
              :key="idx"
              :value="option.value"
              :disabled="option.disabled"
              :class="getConsolidationOptionClass(option)"
            >
              {{ option.text }}
            </option>
          </b-form-select>
        </b-col>

        <b-col sm="4">
          <label for="age-from-selection">Ålder från</label>
          <b-form-select
            id="age-from-selection"
            v-model="form.age.from.selected"
            size="sm"
          >
            <option
              v-for="ageFrom in form.age.from.options"
              :key="ageFrom.value"
              :disabled="ageFrom.value < form.age.to.selected ? false : true"
              :value="ageFrom.value"
            >
              {{ ageFrom.text }}
            </option>
          </b-form-select>
        </b-col>

        <b-col sm="4">
          <label for="age-to-selection">Ålder till</label>
          <b-form-select
            id="age-to-selection"
            v-model="form.age.to.selected"
            size="sm"
          >
            <option
              v-for="ageTo in form.age.to.options"
              :key="ageTo.value"
              :disabled="ageTo.value > form.age.from.selected ? false : true"
              :value="ageTo.value"
            >
              {{ ageTo.text }}
            </option>
          </b-form-select>
        </b-col>

        <b-col sm="4">
          <label for="age-to-selection">Reachvillkor</label>
          <b-form-select
            id="reach-target-group"
            v-model="selectedReachCriteria"
            :disabled="isReachCriteriaDisabled"
            :options="reachCriteriaOptions"
            size="sm"
          />
        </b-col>
      </b-form-row>
      <b-form-row class="mt-3 mb-2">
        <b-col cols="12">
          <b-button
            class="mr-2"
            variant="success"
            size="sm"
            @click="add"
          >
            Lägg till
          </b-button>
          <b-button
            v-if="measures.length > 1"
            class="mr-2"
            variant="danger"
            size="sm"
            @click="deleteAllSelections"
          >
            Ta bort alla
          </b-button>
        </b-col>
      </b-form-row>
      <div class="pt-2">
        <small class="font-weight-bold">Observera att för reach visas max upp till 28 dagar</small>
      </div>
      <b-list-group class="mt-3">
        <b-list-group-item
          v-for="(targetGroup, index) in measures"
          :key="index"
          class="px-4"
        >
          <span :class="getTargetGroupClass(targetGroup)">
            {{ targetGroup.measure_name }}
          </span>
          <b-button
            class="mr-2 float-right"
            variant="danger"
            size="sm"
            @click="deleteSelection(index)"
          >
            Ta bort
          </b-button>
        </b-list-group-item>
      </b-list-group>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Avbryt
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="ok()"
        >
          Spara
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { fetchFormFieldData } from '../../../assets/js/api.js';
import { isEqual } from 'lodash-es';
import globalConfig from "../../../mixins/globalConfig"

export default {
  name: 'TargetGroupModal',
  mixins: [globalConfig],
  props: {
    fieldData: Object,
    chosenPeriod: String,
  },
  data() {
    return {
      selectedReachCriteria: 15,
      reachCriteriaOptions: [
        { value: 1, text: '1 sek', selectedReachCriteriaText: '1 sek' },
        { value: 2, text: '2 sek', selectedReachCriteriaText: '2 sek' },
        { value: 5, text: '5 sek', selectedReachCriteriaText: '5 sek' },
        { value: 10, text: '10 sek', selectedReachCriteriaText: '10 sek' },
        { value: 15, text: '15 sek el 50% av längd', selectedReachCriteriaText: '15 sek/50%' },
        { value: 20, text: '20 sek', selectedReachCriteriaText: '20 sek' },
        { value: 30, text: '30 sek', selectedReachCriteriaText: '30 sek' },
        { value: 60, text: '60 sek', selectedReachCriteriaText: '60 sek' },
        { value: 120, text: '120 sek', selectedReachCriteriaText: '120 sek' },
        { value: 180, text: '180 sek', selectedReachCriteriaText: '180 sek' },
      ],
      measures: [],
      reachMeasures: [],
      reachHeaders: [],
      hasChange: false,
      form: {
        group: {
          selected: 'Alla',
          options: [
            { value: 'Alla', text: 'Alla' },
            { value: 'Kvinnor', text: 'Kvinnor' },
            { value: 'Män', text: 'Män' },
          ],
        },
        consolidation: {
          selected: 8,
          options: [],
        },
        age: {
          from: {
            selected: 3,
            options: [],
          },
          to: {
            selected: 99,
            options: [],
          },
        },
      },
    };
  },
  computed: {
    isReachCriteriaDisabled() {
      let visibleReachSelectors = [
        ...this.fieldData.measurements.options.filter((measure) => measure.showReachSelector),
      ].map((m) => m.value);
      return !visibleReachSelectors.includes(this.fieldData.measurements.selected);
    },
    isReachSelected() {
      let isReachSelected = !this.isReachCriteriaDisabled;
      return isReachSelected;
    },
    apiBodyMeasures() {
      return this.$store.getters['searchApiBody/getPayload'].measures;
    }
  },
  watch: {
    chosenPeriod(period) {
      this.disabledConsolidationsForPeriod(period);
    },
  },
  async created() {
    this.setupTargetGrups();
    this.setupConsolidationPeriods();
    //Default KOsofar
    this.form.consolidation.selected = 999999999;
    if (localStorage.getItem('measures')) this.measures = JSON.parse(localStorage.measures);
    this.$store.commit('searchApiBody/updateMeasures', this.measures);
    if (localStorage.getItem('reachMeasures') && localStorage.getItem('reachHeaders')) {
      this.reachMeasures = JSON.parse(localStorage.reachMeasures);
      this.reachHeaders = JSON.parse(localStorage.reachHeaders);

      let measureType = this.$store.state.reachForm.measure_type.selected;
      let minViewingTime = this.$store.state.reachForm.min_viewing_time.selected;
      this.reachMeasures.forEach((measure) => {
        measure.measure_type = measureType;
        measure.min_viewing_time = minViewingTime;
      });
      this.$store.commit('targetGroups/defineReachHeaders', this.reachHeaders);
      this.$store.commit('reachApiBody/updateMeasures', this.reachMeasures);
      this.$store.commit('consumptionApiBody/updateMeasures', this.measures);
    }
  },
  methods: {
    onKeyUp(event) {
      if (event.key === "Enter" && this.fieldData.showTargetGroupModal) {
        this.fieldData.showTargetGroupModal = false;
        this.saveTargetGroups()      
      }
    },
    showModal() {
      document.addEventListener("keyup", this.onKeyUp);
      this.setTargetGroupsFromLocalStorage();
    },
    setTargetGroupsFromLocalStorage() {
      let storedTargets = localStorage.getItem('measures')
        ? JSON.parse(localStorage.getItem('measures'))
        : [];
      this.measures = storedTargets;
    },
    getConsolidationOptionClass(option) {
      if (option.disabled) return 'disabledConsolidationClass';
    },
    getTargetGroupClass(targetGroup) {
      let isTargetGroupKOChosenPeriod = targetGroup.consolidation_days == -1;
      if (this.chosenPeriod == 'publicationperiod') {
        if (isTargetGroupKOChosenPeriod) return 'showline';
      } else {
        if (!isTargetGroupKOChosenPeriod) return 'showline';
      }
    },
    async setupConsolidationPeriods() {
      let consolidationPeriods = await fetchFormFieldData('ConsolidationPeriods');
      if (consolidationPeriods.statusCode) {
        this.$bvToast.toast(consolidationPeriods.errorMessage, {
          title: 'Varning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      }
      this.form.consolidation.options = [];
      for (let item in consolidationPeriods) {
        let consolidationName =
          consolidationPeriods[item].consolidation_days === 8 ||
          consolidationPeriods[item].consolidation_days === 28
            ? 'KO(' + consolidationPeriods[item].consolidation_days + ')'
            : consolidationPeriods[item].consolidation_name;
        this.form.consolidation.options.push({
          value: consolidationPeriods[item].consolidation_days,
          text: consolidationName,
          disabled: false,
        });
      }
      this.$store.commit('searchApiBody/updateConsolidationPeriods', consolidationPeriods);
      this.disabledConsolidationsForPeriod(this.chosenPeriod);
    },
    disabledConsolidationsForPeriod(period) {
      if (period == 'publicationperiod') {
        for (let i = 0; i < this.form.consolidation.options.length; i++) {
          let option = this.form.consolidation.options[i];
          if (option.value == -1) option.disabled = true;
          else option.disabled = false;
        }
        this.form.consolidation.selected = 8;
      } else {
        for (let i = 0; i < this.form.consolidation.options.length; i++) {
          let option = this.form.consolidation.options[i];
          if (option.value == -1) option.disabled = false;
          else option.disabled = true;
        }
        this.form.consolidation.selected = -1;
      }
    },
    async setupTargetGrups() {
      let targetGroups = await fetchFormFieldData('TargetGroups');

      if (targetGroups.statusCode) {
        this.$bvToast.toast(targetGroups.errorMessage, {
          title: 'Varning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      }

      this.form.age.from.options = [];
      let uniqueTargetGoups = targetGroups.filter(function(obj) {
        return obj.gender === 'Man';
      });

      for (let index in uniqueTargetGoups) {
        this.form.age.from.options.push({
          value: uniqueTargetGoups[index].age_from,
          text: uniqueTargetGoups[index].age_from,
        });
        this.form.age.to.options.push({
          value: uniqueTargetGoups[index].age_to,
          text: uniqueTargetGoups[index].age_to,
        });
      }
    },
    existsInArray(element, array) {
      if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          if (element === array[i]) {
            return true;
          }
        }
      }

      return false;
    },
    add() {   
       let maxTargetGroupCount;
       if (Number.isInteger(this.config_NumberOfTargetGroupsProgram)) maxTargetGroupCount = this.config_NumberOfTargetGroupsProgram
       else maxTargetGroupCount = 8
      if (this.measures.length >= maxTargetGroupCount) {
        this.$bvToast.toast('Max antal målgrupper är '+ maxTargetGroupCount, {
          title: 'Varning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      } else {
        this.addTargetGroup();
      }
    },
    addTargetGroup() {
      let min_viewing_time = 0;
      let selectedReachCriteriaText = '';
      let gender = this.form.group.selected.charAt(0);
      let measurement = this.fieldData.measurements.selected;
      this.fieldData.measurements.options.forEach((element) => {
        if (element.value == this.fieldData.measurements.selected) {
          measurement = element.text;
        }
      });
      let consolidation = this.form.consolidation.selected;
      this.form.consolidation.options.forEach((element) => {
        if (element.value == this.form.consolidation.selected) {
          consolidation = element.text;
        }
      });
      let ageFrom = this.form.age.from.selected;
      let ageTo = this.form.age.to.selected;
      let targetGroupString = `${measurement} ${gender}${ageFrom}-${ageTo} ${consolidation}`;
      if (this.isReachSelected) {
        selectedReachCriteriaText = this.reachCriteriaOptions.filter(function(reachCriteria) {
          if (reachCriteria.value === this) return reachCriteria;
        }, this.selectedReachCriteria)[0].selectedReachCriteriaText;
        targetGroupString += `, ${selectedReachCriteriaText}`;
        min_viewing_time = this.selectedReachCriteria;
      }
      const targetGroupAlreadyExist = this.measures.some(
        (tg) => tg.measure_name === targetGroupString,
      );
      if (targetGroupAlreadyExist) {
        this.$bvToast.toast('Målgruppen finns redan', {
          title: 'Varning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      } else {
        const genderAndAge = `${gender}${ageFrom}-${ageTo}`;
        this.updateMeasuresForSearch(
          targetGroupString,
          min_viewing_time,
          genderAndAge,
          selectedReachCriteriaText,
        );
        if (this.isReachSelected) {
          let reachAbsHeader = this.fieldData.measurements.options.find(
            (measure) => measure.value === this.fieldData.measurements.selected,
          ).reachAbsHeader;
          let reachRelHeader = this.fieldData.measurements.options.find(
            (measure) => measure.value === this.fieldData.measurements.selected,
          ).reachRelHeader;
          reachAbsHeader = `${reachAbsHeader} ${gender}${ageFrom}-${ageTo}`;
          reachRelHeader = `${reachRelHeader} ${gender}${ageFrom}-${ageTo}`;
          this.updateMeasuresForReach(reachAbsHeader, reachRelHeader);
        }
      }
    },
    updateMeasuresForSearch(
      measureName,
      min_viewing_time,
      genderAndAge,
      selectedReachCriteriaText,
    ) {
      let measure = {
        measure_type: this.fieldData.measurements.selected,
        consolidation_days: this.form.consolidation.selected,
        target_group_keys: this.getTargetGroupKeys(),
        min_viewing_time,
        measure_name: measureName,
        isReach: this.isReachSelected,
        genderAndAge,
      };
      if (this.isReachSelected) {
        measure.reachCriteriaText = selectedReachCriteriaText;
      }
      this.measures.push(measure);
    },
    updateMeasuresForReach(reachAbsHeader, reachRelHeader) {
      let measure = {
        measure_type: this.$store.state.reachForm.measure_type.selected,
        consolidation_days: this.form.consolidation.selected,
        target_group_keys: this.getTargetGroupKeys(),
        min_viewing_time: this.$store.state.reachForm.min_viewing_time.selected,
      };
      if (!this.isMeasureAlreadyAdded(measure, this.reachMeasures)) {
        this.reachMeasures.push(measure);
        this.reachHeaders.push({ reachAbsHeader, reachRelHeader });
      }
    },
    isMeasureAlreadyAdded(measure, reachMeasures) {
      for (let i = 0; i < reachMeasures.length; i++) {
        if (isEqual(reachMeasures[i], measure)) return true;
      }
      return false;
    },
    getTargetGroupKeys() {
      let target_group_keys = [];
      this.form.age.to.options.forEach((age) => {
        if (age.value <= this.form.age.to.selected && age.value > this.form.age.from.selected) {
          if (this.form.group.selected === 'Kvinnor' || this.form.group.selected === 'Alla') {
            target_group_keys.push('female_age' + age.value);
          }
          if (this.form.group.selected === 'Män' || this.form.group.selected === 'Alla') {
            target_group_keys.push('male_age' + age.value);
          }
        }
      });
      return target_group_keys;
    },
    deleteSelection(index) {
      this.measures.splice(index, 1);
      this.reachMeasures.splice(index, 1);
      this.reachHeaders.splice(index, 1);
    },
    deleteAllSelections() {
      this.measures = [];
      this.reachMeasures = [];
      this.reachHeaders = [];
    },
    cancelTargetGroups() {
      document.removeEventListener("keyup", this.onKeyUp);
      this.reachHeaders = [...this.$store.state.targetGroups.reachHeaders];
      this.measures = [...this.$store.state.searchApiBody.payload.measures];
      this.reachMeasures = [...this.$store.state.reachApiBody.payload.measures];
    },
    saveTargetGroups() {
      //Add to vuex store
      this.$store.commit('targetGroups/defineReachHeaders', this.reachHeaders);
      this.$store.commit('searchApiBody/updateMeasures', this.measures);
      this.$store.commit('reachApiBody/updateMeasures', this.reachMeasures);
      this.$store.commit('consumptionApiBody/updateMeasures', this.measures);

      //Add measures to local storage
      if (this.measures.length > 0) {
        localStorage.measures = JSON.stringify(this.measures);
      } else {
        //Removes measures data from local storage if length is 0 and if the keys exist
        if (localStorage.getItem('measures')) {
          localStorage.removeItem('measures');
        }
      }
      //Add reach measures to local storage
      if (this.reachMeasures.length > 0 && this.reachHeaders.length > 0) {
        localStorage.reachHeaders = JSON.stringify(this.reachHeaders);
        localStorage.reachMeasures = JSON.stringify(this.reachMeasures);
      } else {
        //Removes reach measures data from local storage if length is 0 and if the keys exist
        if (localStorage.getItem('reachMeasures') && localStorage.getItem('reachHeaders')) {
          localStorage.removeItem('reachMeasures');
          localStorage.removeItem('reachHeaders');
        }
      }
    },
  },
};
</script>
<style scoped>
.showline {
  text-decoration: line-through;
}
.disabledConsolidationClass {
  color: #80808057;
}
</style>
